import React from 'react';
import PropTypes from 'prop-types';

import { TextAreaField } from '@oca/ui';

export function TextAreaFieldWrapper({ input, meta, helperText, ...rest }) {
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched;

  return (
    <TextAreaField
      {...rest}
      {...input}
      error={showError}
      helperText={showError ? meta.error || meta.submitError : helperText}
    />
  );
}

TextAreaFieldWrapper.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
  meta: PropTypes.shape({
    submitError: PropTypes.any,
    dirtySinceLastSubmit: PropTypes.bool,
  }).isRequired,
  // eslint-disable-next-line react/require-default-props
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
